module.exports = __webpack_public_path__ + "img/docs-white.4c90eff6.svg";